import React from "react";
import { Paper, Tab, Tabs } from "@mui/material";

import { TabPanel } from "../../components/ui";
import { ContainerBg } from "../../useGeneralStyles";
import { useSearchParams } from "../../hooks/useSearchParams";
import { useAdminProviderDataContext } from "../../context";

import Withdrawals from "./components/Withdrawals";
import TradersDbList from "./components/TradersDbList";
import WatchlistNotes from "./components/WatchlistNotes ";
import WatchersService from "./components/WatchersService";
import SubmissionToProp from "./components/SubmissionToProp";

const TABS = [
  { label: "Traders DB", value: "traders-db-list", component: TradersDbList },
  { label: "Submission to Prop", value: "submission-to-prop", component: SubmissionToProp },
  { label: "Withdrawals", value: "withdrawals", component: Withdrawals },
  { label: "Watchlist Notes", value: "watchlist-notes", component: WatchlistNotes },
];

const FundedCompliance = (): React.ReactElement => {
  const { user } = useAdminProviderDataContext();
  const { allowed_features } = user;

  const { activeTab, setActiveTab } = useSearchParams({ defaultActiveTab: "traders-db-list" });

  const onChangeActiveTab = (_: React.BaseSyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Paper square>
        <Tabs value={activeTab} onChange={onChangeActiveTab}>
          {TABS.map(({ label, value }) => (
            <Tab key={value} label={label} value={value} />
          ))}

          {allowed_features.access_watchers_service && (
            <Tab label="Services" value="watchers-service" />
          )}
        </Tabs>
      </Paper>

      <ContainerBg sx={{ paddingTop: "20px" }}>
        {TABS.map(({ value, component: Component }) => (
          <TabPanel key={value} value={activeTab} index={value}>
            <Component />
          </TabPanel>
        ))}

        {allowed_features.access_watchers_service && (
          <TabPanel value={activeTab} index="watchers-service">
            <WatchersService />
          </TabPanel>
        )}
      </ContainerBg>
    </>
  );
};

export default FundedCompliance;
